import { colorConstants } from 'config/colorConstants';

//Figma: Global Filter V2 chip > _Remove > x-close. A filled glyph, not a stroked one like
//`Cross`, which is what keeps it readable at the 7.5px the chip draws it at.
const XClose = ({ fill = colorConstants.filterV2Primary }: { fill?: string }) => (
    <svg width="7.5" height="7.5" viewBox="0 0 7.5 7.5" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M5.40405 1.65405C5.52609 1.53201 5.72391 1.53201 5.84595 1.65405C5.96799 1.77609 5.96799 1.97391 5.84595 2.09595L4.19189 3.75L5.84595 5.40405C5.96799 5.52609 5.96799 5.72391 5.84595 5.84595C5.72391 5.96799 5.52609 5.96799 5.40405 5.84595L3.75 4.19189L2.09595 5.84595C1.97391 5.96799 1.77609 5.96799 1.65405 5.84595C1.53201 5.72391 1.53201 5.52609 1.65405 5.40405L3.30811 3.75L1.65405 2.09595C1.53201 1.97391 1.53201 1.77609 1.65405 1.65405C1.77609 1.53201 1.97391 1.53201 2.09595 1.65405L3.75 3.30811L5.40405 1.65405Z"
            fill={fill}
        />
    </svg>
);

export default XClose;
